import { AxiosError, AxiosResponse } from 'axios';
import { useGoogleOneTapLogin } from '@react-oauth/google';
import { authControllerGoogleLogin } from '@/generated/auth/auth';
import { AuthLoginDto } from '@/generated/nabisNYWebAPI.schemas';

export interface GoogleOneTapLoginParams {
  onAuthSuccess: (authResult: AxiosResponse<AuthLoginDto>) => void;
  onAuthError: (e: AxiosError<{ errors: Record<string, string> }>) => void;
  onGoogleError?: () => void;
  disabled?: boolean;
}
export const GoogleOneTapLogin = ({ onAuthSuccess, onAuthError, disabled, onGoogleError }: GoogleOneTapLoginParams) => {
  useGoogleOneTapLogin({
    disabled,
    cancel_on_tap_outside: false,
    onSuccess: (credentialResponse) => {
      authControllerGoogleLogin({ credential: credentialResponse.credential }).then(onAuthSuccess).catch(onAuthError);
    },
    onError: onGoogleError || (() => alert('Login Failed')),
  });
  return <></>;
};
